<script lang="ts" setup>
import LoadingModal from "@/components/LoadingModal.vue";
import ShadowBox from "@/components/ShadowBox.vue";
import StyledAlert from "@/components/StyledAlert.vue";
import { VueDraggableNext } from "vue-draggable-next";
import useCard from "../composables/useCard";

import { useCardsStore } from "@/stores/cards";
import { storeToRefs } from "pinia";

import StyledSwitch from "@/components/StyledSwitch.vue";

const {
  updateCardPriorities,
  deleteCardAsync,
  activeRefetch,
  inactiveRefetch,
  activeIsLoading,
} = useCard({ params: {}, immediate: true });

const { activeCards } = storeToRefs(useCardsStore());

const updatePriorities = async () => {
  await updateCardPriorities();
};

const disableCard = async (id: number) => {
  await deleteCardAsync({
    params: { id: id },
    config: {
      onSuccessToast: "Tarjeta desactivada correctamente",
      raiseToast: true,
    },
  });
  await activeRefetch();
  await inactiveRefetch();
};
</script>

<template>
  <!-- data-screenshot-exclude: dato de tarjeta fuera de la captura del widget de bugs (ver useScreenCapture.ts). Pinta numero, expiracion y titular; Card.number es un string a secas,
       nada garantiza que venga enmascarado. -->
  <div class="flex flex-col items-center" data-screenshot-exclude>
    <!-- <h1 class="mb-3 font-extrabold text-3xl uppercase">Prioridad de tarjetas</h1> -->
    <ShadowBox
      class="h-[650px] overflow-y-auto overflow-x-hidden bg-white w-full"
    >
      <VueDraggableNext
        v-model="activeCards"
        @update="updatePriorities"
        class="space-y-3 flex flex-col items-center"
      >
        <transition-group>
          <StyledAlert
            v-if="activeCards.length == 0"
            hideNav
            type="Info"
            titleStyle="text-base font-bold w-full"
            :title="'No hay tarjetas activas'"
          />
          <div
            v-else
            class="flex items-center gap-2 shadow-md"
            v-for="element in activeCards"
            :key="element.id"
          >
            <div
              class="w-96 h-56 bg-red-100 rounded-xl relative text-white shadow-2xl"
            >
              <img
                class="relative object-cover w-full h-full rounded-xl"
                src="https://i.imgur.com/kGkSg1v.png"
              />

              <div class="w-full px-4 absolute top-8">
                <div class="flex justify-between">
                  <h1 class="font-bold uppercase">Enlaceforte</h1>
                  <StyledSwitch
                    v-model:enabled="element.enabled"
                    @update:enabled="disableCard(element.id)"
                    :class="[element.enabled ? '' : '']"
                  />
                </div>

                <div class="flex justify-between mt-7">
                  <p class="font-medium text-base my-auto">
                    Prioridad:
                    <span class="text-xl font-bold">{{
                      element.priority
                    }}</span>
                  </p>

                  <div v-switch="element.brand">
                    <img
                      v-if="element.brand === 'Amex'"
                      class="w-32 h-14"
                      src="https://www.kreiconceptstore.com/media/wysiwyg/american-express.png"
                    />
                    <img
                      v-else-if="element.brand === 'Visa'"
                      class="w-28 h-14"
                      src="https://1000marcas.net/wp-content/uploads/2019/12/VISA-Logo.png"
                    />
                    <img
                      v-else-if="element.brand === 'MasterCard'"
                      class="w-28 h-14"
                      src="https://download.logo.wine/logo/Mastercard/Mastercard-Logo.wine.png"
                    />
                  </div>
                </div>
                <div class="">
                  <p class="font-medium mt-5">
                    {{ element.cardeable?.fullName }}
                  </p>
                </div>
                <div class="flex justify-between">
                  <p class="font-medium">
                    {{ element.number }}
                  </p>
                  <p class="font-medium text-sm">
                    {{ element.expirationDate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </VueDraggableNext>
    </ShadowBox>
  </div>

  <LoadingModal :when="activeIsLoading" />
</template>

<style scoped>
/* Ocultar la barra de desplazamiento predeterminada */
.overflow-y-auto::-webkit-scrollbar {
  display: none;
}

/* Estilos para la barra de desplazamiento personalizada */
.overflow-y-auto {
  scrollbar-width: none;
  /* Firefox */
}

/* Estilo para el contenedor de la barra de desplazamiento personalizada */
.overflow-y-auto::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* Color de fondo */
  border-radius: 10px;
  /* Radio de borde */
}

/* Estilo para el indicador de la barra de desplazamiento personalizada */
.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #888;
  /* Color del indicador */
  border-radius: 10px;
  /* Radio de borde */
}

/* Estilo para el indicador de la barra de desplazamiento personalizada cuando se desplaza */
.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* Cambiar color al pasar el mouse */
}
</style>
